import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

export function* markDocumentReadGrowUpFarms({ payload }) {
  yield put(actions.setGrowUpFarmsReadingLoading(true));
  try {
    yield call(Api.markDocumentRead, {
      document_read: payload,
      growUpFarms: true,
    });
    yield put(actions.setGrowUpFarmsReadingLoading(false));
  } catch (error) {
    yield put(actions.addError("Reading List GrowUp Farms", error));
    yield put(actions.setGrowUpFarmsReadingLoading(false));
  }
}
export function* submitGrowUpFarmsQuestionnaireSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.submitGrowUpFarmsQuestionnaire, formName, formContent);
  } catch (error) {
    yield put(actions.addError("Submit GrowUp Farms Questionnaire", error));
  }
}
export function* submitGrowUpFarmsFoodQuestionnaireSaga({ payload }) {
  yield put(actions.setGrowUpFarmsFoodQuestionnaireLoading(true));
  try {
    const { formName, formContent } = payload;
    const response = yield call(
      Api.submitGrowUpFarmsQuestionnaire,
      formName,
      formContent
    );
    yield put(
      actions.setGrowUpFarmsFoodQuestionnaireResults(response.data.testResults)
    );
    yield put(actions.setGrowUpFarmsFoodQuestionnaireLoading(false));
  } catch (error) {
    yield put(
      actions.addError("Submit GrowUp Farms Food Questionnaire", error)
    );
    yield put(actions.setGrowUpFarmsFoodQuestionnaireLoading(false));
  }
}
